import React from "react";
import { Box, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { CADENCE_COLORS, formatCadenceLine } from "../churnUtils";

const CadenceLine = ({ customer }) => {
  const color = CADENCE_COLORS[customer?.cadence_status] || CADENCE_COLORS.none;
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "6px", minWidth: 0 }}>
      <FiberManualRecordIcon sx={{ fontSize: 8, color, flexShrink: 0 }} />
      <Typography
        sx={{
          fontSize: "13px",
          color: "#6B7280",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {formatCadenceLine(customer)}
      </Typography>
    </Box>
  );
};

export default CadenceLine;
